import { Field, DateDropdown } from '../../../libs/gs-component-form';
import { FormColumn, FormRow } from '@xo-union/tk-component-form-grid';
import React from 'react';
import styles from './style.scss';
import { Field as FormikField } from 'formik';
import WeddingLocationField from './WeddingLocationField';
import moment from 'moment';

const WeddingInfoFormBody: React.FC = () => {
  return (
    <div className={styles.group}>
      <FormRow>
        <FormColumn md>
          <FormikField name="firstName" label="First Name" component={Field} data-testid="first-name" />
        </FormColumn>
        <FormColumn md>
          <FormikField name="lastName" label="Last Name" component={Field} data-testid="last-name" />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn md>
          <FormikField
            name="fianceFirstName"
            label={`Partner's First Name`}
            component={Field}
            data-testid="fiance-first-name"
          />
        </FormColumn>
        <FormColumn md>
          <FormikField
            name="fianceLastName"
            label={`Partner's Last Name`}
            component={Field}
            data-testid="fiance-last-name"
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn xs="12" className={styles.datePickerContainer}>
          <FormikField
            name="weddingDate"
            label="Wedding Date"
            component={DateDropdown}
            readOnly={false}
            returnedDateFormat={'YYYY-MM-DD'}
            isOutsideRange={(momentDate: moment.Moment) => !momentDate.isSameOrAfter(moment().startOf('day'))}
          />
        </FormColumn>
      </FormRow>
      <FormRow>
        <FormColumn xs="12" className={styles.weddingLocation}>
          <WeddingLocationField name="weddingLocation" label="Wedding Location (Optional)" />
        </FormColumn>
      </FormRow>
    </div>
  );
};

export default WeddingInfoFormBody;
